// removed by extract-text-webpack-plugin
module.exports = {"strokeMarketplaceColor":"IconKeysSuccess__strokeMarketplaceColor__3rBmQ","fillSuccessColor":"IconKeysSuccess__fillSuccessColor__3kLfM","strokeLightColor":"IconKeysSuccess__strokeLightColor__2jEv8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/IconKeysSuccess/IconKeysSuccess.css
// module id = 1842
// module chunks = 0